import Nirman from '../../assets/portfolio/nirmantraders.png'
import diagnomitra from'../../assets/portfolio/diagnomitra.png'
import entdelhi from '../../assets/portfolio/entdelhi.png'
import placemybrand from'../../assets/portfolio/placemybrand.png'
import edusarthi from '../../assets/portfolio/edusarthi.png'
import drivingschool from '../../assets/portfolio/drivingschool.png'
import minimoon from '../../assets/portfolio/minimoon.png'

const portfolio=()=>{
    return(
        <>
            <div className="container-fluid p-0 portfolio" style={{background: "linear-gradient(to right, #3e13c0ff ,  #426fecff)"}}>
                {/* <p style={{color:'#ffffff'}}>Portfolio</p> */}
                <div className="slider-wrapper">
                    <div className="slider-text">
                        Work For Our Customer Work For Our Customer Work For Our Customer Work For Our Customer Work For Our Customer Work For Our Customer
                    </div>
                    <div className="slider-text">
                        Work For Our Customer Work For Our Customer Work For Our Customer Work For Our Customer Work For Our Customer Work For Our Customer
                    </div>
                </div>
                <div className="container servicesContent" style={{padding:'30px'}}>

                    {/* <h1 style={{color:'#ffffff', fontWeight:'500', fontFamily:'Bungee, sans-serif'}}>Work For Our Customer</h1> */}
                    
                    <div className='mt-5 justify-content-center'>
                        <div
                            class="row g-2"
                        >

                            <div class="col-md-4  ">
                                <div>
                                {/* <img src="" alt="computer" />    */}
                                <h6 className='text-light'>Nirman Traders</h6>
                                <p className='text-light'>Mobile And Accessories WholeSaler</p>
                                <div className='portfolioContent'>
                                    <img src={Nirman} alt="" className='img-fluid'/>                                    
                                </div>
                                </div> 
                             
                            </div>

                            <div class="col-md-4 ">
                                <div>
                                <h6 className='text-light'>Diagnomitra</h6>
                                <p className='text-light'>Medical Healthcare Institure</p>
                                <div className='portfolioContent'>
                                    <img src={diagnomitra} alt="" className=' imagescroll img-fluid'/>
                                </div>
                                </div>
                            </div>
                            <div class="col-md-4  ">
                                <div>
                                <h6 className='text-light'>ENT Delhi</h6>
                                <p className='text-light'>ENT Hospital </p>
                                <div className='portfolioContent'>
                                   <img src={entdelhi} alt="" className='img-fluid'/>
                                </div>
                                </div>
                            </div>                            
                        </div>

                        
                        <div
                            class="row mt-5 g-2"
                        >
                            <div class="col-md-4  ">
                                <div>
                                <h6 className='text-light'>PlacemyBrand</h6>
                                <p className='text-light'>Influencer Marketing Portal</p>
                                <div className='portfolioContent'>
                                   <img src={placemybrand} alt="" className='img-fluid'/>
                                </div>
                                </div>
                            </div>
                            <div class="col-md-4   ">
                                <div>
                                <h6 className='text-light'>EduSarthi</h6>
                                <p className='text-light'>Online Teaching Portal</p>
                                <div className='portfolioContent'>
                                   <img src={edusarthi} alt="" className='img-fluid'/>
                                </div>
                                </div>
                            </div>

                            <div class="col-md-4   ">
                                <div>
                                <h6 className='text-light'>Scardriving</h6>
                                <p className='text-light'>Driving School Website</p>
                                <div className='portfolioContent'>
                                   <img src={drivingschool} alt="" className='img-fluid'/>
                                </div>
                                </div>
                            </div>

                            <div
                            class="row mt-5 g-2"
                            >
                            <div class="col-md-4   ">
                                <div>
                                <h6 className='text-light'>Minimoon</h6>
                                <p className='text-light'>Kids Clothing Store</p>
                                <div className='portfolioContent'>
                                   <img src={minimoon} alt="" className='img-fluid'/>
                                </div>
                                </div>
                            </div>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>
        </>
    )
}

export default portfolio